import GroupRenderer from "./group_renderer"
import messageResource from "../messageResource"
import {atImgPath} from "../atBrowserUtils"

export default class UserGroupRenderer extends GroupRenderer {
    buildFolderImgCell(group) {
        const folderImgTd = document.createElement("td");
        folderImgTd.className = this.folderImgClassName;
        const folderImg = document.createElement("img");
        if (this.validatorGroupStrategy.isNullGroup(group)) {
            folderImg.src = atImgPath("user_group_lightbox/no-group-icon.png");
        } else {
            folderImg.src = atImgPath("user_group_lightbox/group-folder-icon.png");
        }
        folderImgTd.appendChild(folderImg);

        return folderImgTd;
    }

    /**
     * Build columns for group row
     */
    fillTable(table, group) {
        const tr = document.createElement('tr');
        tr.appendChild(this.buildFolderImgCell(group));
        tr.appendChild(this.buildNameCell(group));
        tr.appendChild(this.buildCountCell(group));
        tr.appendChild(this.buildDeleteCell(group));
        tr.appendChild(this.buildConfirmDeleteCell(group));
        tr.appendChild(this.buildWaitingAnimationCell(group));
        table.appendChild(tr);
    }

    generateDeleteConfirmMessage()
    {
        return messageResource.getEscapedMessage("group_management.confirm_delete.message.part_1.user_groups") +
               " " + messageResource.getMessage("group_management.confirm_delete.message.part_2.user_groups");
    }


}


// WEBPACK FOOTER //
// ./web/js/groupManagement/user_group_renderer.js